import React from 'react'
import { styled } from 'linaria/react'

const SortContainer = styled.div`
   display: flex;
   flex-direction: column;
   padding-bottom: 0.75rem;

   /* Larger touch targets, the whole row is clickable */
   &.is-large {
      padding-bottom: 0;

      > div {
         margin-bottom: 0;
      }

      input[type='checkbox'] {
         flex-shrink: 0;
         width: 22px;
         height: 22px;
         margin-right: 0;

         &:checked::before {
            width: 10px;
            height: 10px;
         }
      }

      label {
         flex-grow: 1;
         padding: 0.75rem 0 0.75rem 0.85rem;
         font-size: 1rem;
      }
   }
`

const SortOption = styled.div`
   display: flex;
   align-items: center;
   margin-bottom: 0.25rem;

   input[type='checkbox'] {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 16px;
      height: 16px;
      margin-right: 0.5rem;
      border: 2px solid #707070;
      border-radius: 50%;
      outline: none;
      cursor: pointer;
      position: relative;
      background-color: white;
      &:hover {
         background-color: #dcdcdc;
      }
      &:checked {
         background-color: var(--color-vb-blue);
         border-color: var(--color-vb-blue-darker);
         &:hover {
            opacity: 0.8;
         }
      }

      &:checked::before {
         content: '';
         position: absolute;
         top: 50%;
         left: 50%;
         width: 8px;
         height: 8px;
         background-color: white;
         border-radius: 50%;
         transform: translate(-50%, -50%);
         &:hover {
            opacity: 0.8;
         }
      }
   }

   label {
      cursor: pointer;
      font-weight: 600;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
   }
`

/**
 * SortList Component
 *
 * @param {Array} options - Array of sorting options with `label` and `value`.
 * @param {Array} filters - Current active filters.
 * @param {function} isSelected - Function to determine if a sorting option is selected.
 * @param {function} onSortChange - Callback when a sort option is selected.
 */
const SortList = ({
   fieldName,
   options = [],
   filters = [],
   isSelected,
   onSortChange,
   large = false,
}) => {
   return (
      <SortContainer className={large ? 'is-large' : undefined}>
         {options.map(({ label, value }, index) => (
            <SortOption key={value}>
               <input
                  type="checkbox"
                  name="sortOptions"
                  value={value}
                  checked={isSelected({ fieldName, value, filters })}
                  onChange={() =>
                     onSortChange({
                        fieldName,
                        value,
                     })
                  }
                  id={`${fieldName}-sort-option-${index}${large ? '-large' : ''}`}
               />
               <label htmlFor={`${fieldName}-sort-option-${index}${large ? '-large' : ''}`}>{label}</label>
            </SortOption>
         ))}
      </SortContainer>
   )
}

export default SortList
